import React from 'react';

import { Spinner } from 'dibs-elements/exports/Spinner';
import overlayStyles from './OverlaySpinnerAdditional.scss';

export function Loader() {
    return (
        <div className={overlayStyles.container}>
            <Spinner />
        </div>
    );
}
